var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidateMeniUcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79167 1.66406H10.2084C10.825 1.66406 11.3333 2.1724 11.3333 2.78907V4.02238C11.3333 4.47238 11.05 5.03073 10.775 5.31407L8.35838 7.4474C8.02504 7.73073 7.80001 8.28905 7.80001 8.73905V11.1557C7.80001 11.4891 7.57502 11.9391 7.29169 12.1141L6.50835 12.6224C5.77502 13.0724 4.76666 12.5641 4.76666 11.6641V8.68906C4.76666 8.29739 4.54168 7.78907 4.31668 7.50574L2.18335 5.25573C1.90002 4.97239 1.67503 4.47239 1.67503 4.13072V2.83907C1.66669 2.1724 2.175 1.66406 2.79167 1.66406Z",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 10.0005V12.5005C1.66663 16.6672 3.33329 18.3339 7.49996 18.3339H12.5C16.6666 18.3339 18.3333 16.6672 18.3333 12.5005V7.50053C18.3333 4.90053 17.6833 3.26719 16.1749 2.41719C15.7499 2.17552 14.9 1.99219 14.125 1.86719",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.832H15",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 14.168H15",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateMeniUcon);
export default __webpack_public_path__ + "static/media/CandidateMeniUcon.64151c6f9c69be111af94dfb35331c16.svg";
export { ForwardRef as ReactComponent };